/**
 * Magazin entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';
import { getI18nInstance as i18n } from '@/i18n';
import { globalVar, frontendUrl } from '@/helpers/globals';

export class Magazin extends BaseModel {
    defaults() {
        return {
            id: null,
            uuid: null,
            title: null,
            seo_title: null,
            socialmedia_title: null,
            subtitle: null,
            lead_text: null,
            page_id: null, // 1: Agenda, 2: Magazin, 3: Service, 4: Kulturplatz, 5: Freie Seiten
            created: null,
            modified: null,
            creator_id: null,
            publish_from: null,
            publish_to: null,
            slug: null,
            is_draft: null,
            featured_image_id: null,
            featured_image_caption: null,
            featured_img_crop_config: null,
            link: null,
            to_newsletter: null,
            show_disqus: null,
            order_number: null,
            carousel_order_number: null,
            has_video: null,
            has_comments: null,
            has_photo_gallery: null,
            overview_imagesize: null,
            dossier_ids: null,
            autor_address_id: null,
            is_featured: null,
            front_header_from: null,
            front_header_to: null,
            add_fb_js_sdk: null,

            // view properties
            page_title: null,
            creator: null,
            is_published: null,
            tags: null,
            tag_names: null,
            genre_group_ids: null,
            genre_group_names: null,
            in_mediamirror: null,
            dossiers: null,
            autor_title: null,
            autor_name: null,
            autor_description: null,
            autor_email: null,
            autor_web: null,
            autor_social_media: null,
            autor_featured_image_id: null,
            is_front_header: null, // marked as top thema, and is active right now:
            is_top_thema: null, // marked as top thema, but not necessarily now (but was in the past):
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            is_featured: Boolean,
            is_published: Boolean,
            show_disqus: Boolean,
            has_video: Boolean,
            has_comments: Boolean,
            has_photo_gallery: Boolean,
            add_fb_js_sdk: Boolean,

            created: dayjs,
            modified: dayjs,
            publish_from: dayjs,
            publish_to: dayjs,
            front_header_from: dayjs,
            front_header_to: dayjs,
        };
    }

    entityName() {
        return 'magazin';
    }

    get overviewImagesizeText() {
        switch (this.overview_imagesize) {
            case '1':
                return i18n().t('one_tile');
            case '2H':
                return i18n().t('2_tiles_h');
            default:
                return '';
        }
    }

    get imageUrl() {
        let conf = globalVar('featured_images_config').magazin.thumb;
        return `${globalVar('imageroot')}/magazin/${this.id}/${conf.ident}.${conf.format}`;
    }

    get detailPreviewUrl() {
        return frontendUrl(`/magazin/${this.slug || this.id}`, { preview: 'enable' });
    }

    get detailUrl() {
        return frontendUrl(`/magazin/${this.slug || this.id}`);
    }

    get searchPreviewUrl() {
        return frontendUrl(`/magazin/?preview=enable&id=${this.id}#id=${this.id}`);
    }

    get autorDisplayTitle() {
        if (this.autor_name) {
            let ret = `${this.autor_name}`;
            if (this.autor_title) {
                ret += ` (${this.autor_title})`;
            }
            return ret;
        } else {
            return this.autor_title || '- kein Titel -';
        }
    }
}

export class MagazinCollection extends BaseCollection {
    options() {
        return {
            model: Magazin,
        };
    }

    entityName() {
        return 'magazin';
    }
}
